<template>
  <div class="header__navbar__profile__section"  @click="showProfile = !showProfile">
    <span>マイページ</span>
    <ul
      class="header__navbar__profile__dropdown"
      v-if="showProfile"
      v-click-outside="() => showProfile = false"
    >
      <li class="header__navbar__profile__dropdown__item">
        <a href="/users/edit">
          <img :src="profileIcon" width="15px" height="15px" alt />
          プロフィール
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/checkout">
          <img :src="cartIcon" width="15px" height="15px" alt />
          カート
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/orders">
          <img :src="orderHistoryIcon" width="15px" height="15px" alt />
          注文履歴
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item large">
        <a href="/orders/csv">
          <img :src="orderHistoryIcon" width="15px" height="15px" alt />
          注文履歴CSVダウンロード
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/receivers">
          <img :src="receiverIcon" width="15px" height="15px" alt />
          アドレス帳：お届け先
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/senders">
          <img :src="senderIcon" width="15px" height="15px" alt />
          アドレス帳：贈り主
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/plates">
          <img :src="woodBillIcon" width="15px" height="15px" alt />
          木札帳：木札
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/invoices">
          <img :src="paymentIcon" width="15px" height="15px" alt />
          アドレス帳：請求書送付先
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item" v-if="user.had_relations">
        <a href="/user_relations">
          <img :src="userRelationsIcon" width="15px" height="15px" alt />
          連携アカウント一覧
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href="/alerts">
          <i class="fas fa-bell"></i>
          アラート
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item hidden">
        <a href="/points">
          <img :src="pointsIcon" width="15px" height="15px" alt />
          ポイント履歴
        </a>
      </li>
      <li class="header__navbar__profile__dropdown__item">
        <a href @click.prevent="signOut" id="logoutBtn">
          <img :src="logOutIcon" width="15px" height="15px" alt/>
          ログアウト
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

import profileIcon from "images/file-icon.svg";
import cartIcon from "images/bag-icon.svg";
import orderHistoryIcon from "images/order-history-icon.svg";
import receiverIcon from "images/truck-icon.svg";
import senderIcon from "images/parcel.svg";
import woodBillIcon from "images/package-icon.svg";
import paymentIcon from "images/credit-icon.svg";
import logOutIcon from "images/door-icon.svg";
import userRelationsIcon from "images/user-relations-icon.svg";
import pointsIcon from "images/h-coin-gray.svg";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    pcOnly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      showProfile: false
    };
  },
  created: function() {
    this.profileIcon = profileIcon;
    this.cartIcon = cartIcon;
    this.orderHistoryIcon = orderHistoryIcon;
    this.receiverIcon = receiverIcon;
    this.senderIcon = senderIcon;
    this.woodBillIcon = woodBillIcon;
    this.paymentIcon = paymentIcon;
    this.logOutIcon = logOutIcon;
    this.userRelationsIcon = userRelationsIcon;
    this.pointsIcon = pointsIcon;
  },
  methods: {
    signOut: async function() {
      await this.$axios.delete("/users/sign_out", {
        data: {
          authenticity_token: document.querySelector("meta[name=csrf-token]")
            .content
        }
      });

      this.$toasted.success("ログアウトされました。", {
        duration: 500,
        theme: "bubble",
        onComplete: () => {
          window.location.replace("/");
        }
      });
    }
  }
};
</script>

<style>
</style>